import { isNil, prop, pipe, cond, equals, always, T, path, length, has, find, propEq } from 'ramda';

const defaultUnitOfMeasureKey = 'defaultUnitOfMeasure'
const oldPathToUnitOfMeasure = path([ 'units', 0, 'kg', 'unitOfMeasure' ])

const lengthOfUnitsIsOne = pipe(prop('units'), length, equals(1))
const firstUnitOfMeasure = path([ 'units', 0, 'unitOfMeasure' ])
const hasDefaultUnitOfMeasure = has(defaultUnitOfMeasureKey)
const extractUnitsOfMeasure = (meta) => prop('units', meta)

const extractUnitOfMeasureFromNewStructure = cond([
  [ lengthOfUnitsIsOne, firstUnitOfMeasure ],
  [ T, oldPathToUnitOfMeasure ]
])

const exctactDefaultUnitOfMeasure = (meta) => {
  const defaultUnitOfMeasure = prop(defaultUnitOfMeasureKey, meta)
  const isDefaultUnitOfMeasure = propEq('unitOfMeasure', defaultUnitOfMeasure)
  return find(isDefaultUnitOfMeasure)(extractUnitsOfMeasure(meta))
}

const extractUnitOfMeasure = cond([
  [ hasDefaultUnitOfMeasure, exctactDefaultUnitOfMeasure ],
  [ (meta) => isNil(oldPathToUnitOfMeasure(meta)), extractUnitOfMeasureFromNewStructure ],
  [ T, oldPathToUnitOfMeasure ]
])

const unitOfMeasure = pipe(
  prop('meta'),
  cond([ [ equals(undefined), always(undefined) ], [ T, extractUnitOfMeasure ] ])
)

export const getUnitsOfMeasure = pipe(
  prop('meta'),
  cond([
    [ equals(undefined), always([ ]) ],
    [ T, extractUnitsOfMeasure ]
  ])
)

export default unitOfMeasure;



// WEBPACK FOOTER //
// ./src/components/questions/common/unitOfMeasure.js